module.exports = __webpack_public_path__ + "img/pc_header_bg_old.defee64.webp";